import { render, staticRenderFns } from "./invoicment.vue?vue&type=template&id=433ddb6c&"
import script from "./invoicment.vue?vue&type=script&lang=js&"
export * from "./invoicment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports